import { GameClient, GameClientLoadingState } from './gameClient';
import { ClientTypeSwitchButtonClickedCommand } from './clientCommands/clientTypeSwitchButtonClickedCommand';
import { Localization } from '../localization/localization';
import { toastMessage } from '../../s/components/toast-message/toast-message';
import consoleLogger from '../logger/consoleLogger';

const logger = consoleLogger.getPrefixedCopy('CLIENT_SWITCH_BUTTON');

const BUTTON_SELECTOR = '#js-client_switch_button';
const BUTTON_TEXT_SELECTOR = '.navigation_button_name';

/**
 * @description
 * The only owner of the client switch button DOM state.
 *
 * The button text is owned by the game client, so the site has no localization key for it.
 * The state is kept nowhere but in the page DOM: the markup is rendered hidden, so a page reload
 * or a client type switch always brings the button back to the hidden state without any extra code.
 */
export class ClientSwitchButton {
    public static init(): void {
        $(document).on('click', BUTTON_SELECTOR, ClientSwitchButton.handleClick);
    }

    public static setState(visible: boolean, text: string): void {
        const $button = $(BUTTON_SELECTOR);

        if (!$button.length) {
            logger.warning('button is not rendered on the current page');
            return;
        }

        if (!visible || !text) {
            $button.hide();
            return;
        }

        $button.find(BUTTON_TEXT_SELECTOR)
            .text(text);
        $button.show();
    }

    private static handleClick(): void {
        const gameClient = GameClient.getInstance();

        if (gameClient.getLoadingState() !== GameClientLoadingState.LOADED) {
            toastMessage.show(Localization._n('account.wait_for_client_to_load'));
            return;
        }

        gameClient.sendCommand(new ClientTypeSwitchButtonClickedCommand());
    }
}
